import React from "react";

export const Layout = ({ children }) => {
  return (
    <div className="px-4 xl:px-10 max-w-[1440px] mx-auto text-black h-full min-h-screen">
      {children}
    </div>
  );
};
